(function () {
  'use strict';
  var base = 'https://purebreed.0088.co.uk/webhooks/native-marketing/';
  var visitorKey = 'pk-shopify-forms-identified';
  var cooldownKey = 'pk-shopify-forms-popup';
  var popup;
  var showing = false;
  var presentationURL = document.currentScript.getAttribute('data-pk-original-forms');
  var presentationPromise;
  function read(key) { try { return localStorage.getItem(key); } catch (_) { return null; } }
  function write(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  function uuid() { return window.crypto.randomUUID(); }
  async function request(path, body) {
    var response = await fetch(base + path, { method: body ? 'POST' : 'GET', headers: body ? { 'Content-Type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined, credentials: 'omit', keepalive: path === 'event' });
    var result = await response.json();
    if (!response.ok || result.ok === false) throw new Error(result.error || 'Please try again.');
    return result;
  }
  function mayClose(key) {
    return key !== 'wishlist' || document.body.hasAttribute('data-pk-wishlist-shop');
  }
  function fieldKey(name) {
    return name === 'emailField' ? 'email' : ['tcpa', 'gdpr'].includes(name) ? 'consent' : name.replace(/^custom_/, '');
  }
  function bind(form, key, meta, host) {
    var submissionId;
    var pending = false;
    var prefix = 'omnisend-form-' + meta.id;
    var success = host.querySelector('#' + prefix + '-success-sections-promotional-form');
    var status = form.querySelector('.' + prefix + '-submit-error');
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
    form.dataset.nativeForm = key;
    if (key === 'breeder') {
      host.querySelectorAll('a[href]').forEach(function (link) {
        if (link.getAttribute('href') === 'Learn%20More') link.href = '/pages/for-breeders';
        if (form.ownerDocument !== document && link.target !== '_blank') link.target = '_top';
      });
    }
    form.querySelectorAll('input').forEach(function (input) {
      // Empty maxlength is provider metadata, not a zero-character limit.
      if (input.getAttribute('maxlength') === '') input.removeAttribute('maxlength');
    });
    form.querySelectorAll('[role="combobox"]').forEach(function (combo) {
      var list = host.querySelector('#' + combo.getAttribute('aria-controls'));
      var options = Array.from(list.querySelectorAll('[role="option"]'));
      var activeIndex = 0, placement = 'bottom', typed = '', typeTimer, blurTimer;
      var view = form.ownerDocument.defaultView;
      function positionList() {
        if (combo.getAttribute('aria-expanded') !== 'true') return;
        var rect = combo.getBoundingClientRect();
        list.style.width = rect.width + 'px'; list.style.left = rect.left + 'px';
        list.style.top = (placement === 'bottom' ? rect.bottom : rect.top - list.getBoundingClientRect().height) + 'px';
      }
      function toggle(open) {
        list.style.display = open ? '' : 'none'; combo.setAttribute('aria-expanded', String(open));
        list.setAttribute('aria-expanded', String(open));
        if (open) {
          clearTimeout(blurTimer);
          focusOption(activeIndex);
          // Preserve the original SDK's top/bottom placement, not a clamped overlap.
          var rect = combo.getBoundingClientRect();
          placement = view.innerHeight - (rect.bottom + list.getBoundingClientRect().height) < 0 ? 'top' : 'bottom';
          positionList();
          view.addEventListener('scroll', positionList, true); view.addEventListener('resize', positionList);
        } else {
          view.removeEventListener('scroll', positionList, true); view.removeEventListener('resize', positionList);
        }
      }
      function focusOption(index) {
        activeIndex = index;
        options.forEach(function (item, i) { item.classList.toggle('visually-focused-option', i === index); });
        combo.setAttribute('aria-activedescendant', options[index].id);
      }
      function choose(option) {
        combo.dataset.value = option.dataset.value;
        options.forEach(function (item) { item.setAttribute('aria-selected', String(item === option)); item.classList.toggle('selected-option', item === option); });
        focusOption(options.indexOf(option));
        combo.querySelector('[class$="-select-text"]').textContent = option.textContent.trim();
        combo.querySelector('[class$="-select-text"]').style.display = '';
        combo.querySelector('[class$="-select-placeholder"]').style.display = 'none';
        toggle(false); combo.focus(); submissionId = null;
      }
      combo.addEventListener('click', function () { toggle(combo.getAttribute('aria-expanded') !== 'true'); });
      options.forEach(function (option) { option.addEventListener('click', function () { choose(option); }); });
      combo.addEventListener('keydown', function (event) {
        var open = combo.getAttribute('aria-expanded') === 'true', keyName = event.key;
        if (!open && ['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(keyName)) { event.preventDefault(); focusOption(activeIndex); toggle(true); return; }
        if (open && keyName === 'Escape') { event.stopPropagation(); toggle(false); return; }
        if (open && (['Enter', ' '].includes(keyName) || keyName === 'ArrowUp' && event.altKey)) { event.preventDefault(); choose(options[activeIndex]); return; }
        if (keyName === 'Tab') { if (open) choose(options[activeIndex]); return; }
        if (['ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'].includes(keyName)) {
          event.preventDefault();
          if (keyName === 'Home') activeIndex = 0;
          else if (keyName === 'End') activeIndex = options.length - 1;
          else activeIndex = Math.max(0, Math.min(options.length - 1, activeIndex + (keyName === 'ArrowDown' ? 1 : keyName === 'ArrowUp' ? -1 : keyName === 'PageDown' ? 10 : -10)));
          if (!open) toggle(true);
          focusOption(activeIndex); options[activeIndex].scrollIntoView({block:'nearest'});
        } else if (/^[a-zA-Z]$/.test(keyName)) {
          typed += keyName.toLowerCase(); clearTimeout(typeTimer); typeTimer = setTimeout(function () { typed = ''; }, 500);
          var found = options.findIndex(function (item) { return item.textContent.trim().toLowerCase().startsWith(typed); });
          if (found >= 0) { if (!open) toggle(true); focusOption(found); }
        }
      });
      combo.addEventListener('focus', function () { clearTimeout(blurTimer); });
      combo.addEventListener('blur', function (event) {
        clearTimeout(blurTimer);
        if (list.contains(event.relatedTarget)) return;
        if (event.relatedTarget) toggle(false);
        else blurTimer = setTimeout(function () { if (form.ownerDocument.activeElement !== combo && combo.getAttribute('aria-expanded') === 'true' && !list.matches(':hover')) toggle(false); }, 250);
      });
      host.addEventListener('click', function (event) { if (!combo.parentElement.contains(event.target)) toggle(false); });
    });
    function valuesAndValidity() {
      var values = {}, valid = true, firstInvalid, messages = [];
      form.querySelectorAll('input[name]').forEach(function (input) {
        var name = fieldKey(input.name);
        if (input.type === 'checkbox') values[name] = input.checked;
        else if (input.type !== 'radio' || input.checked) values[name] = input.value.trim();
      });
      form.querySelectorAll('[role="combobox"][name]').forEach(function (combo) { values[fieldKey(combo.getAttribute('name'))] = combo.dataset.value || ''; });
      meta.fields.forEach(function (field) {
        var controls = Array.from(form.querySelectorAll('[name]')).filter(function (control) { return fieldKey(control.getAttribute('name')) === field.key; });
        var control = controls[0];
        if (!control) throw new Error('The form is out of date. Please refresh the page and try again.');
        var missing = field.required && !values[field.key];
        var malformed = field.type === 'email' && values[field.key] && !control.validity.valid;
        if (field.type === 'tel' && values[field.key]) {
          var phone = values[field.key];
          malformed = !/^\+?[\d ().-]+$/.test(phone) || phone.replace(/\D/g, '').length < 8 || phone.replace(/\D/g, '').length > 15;
        }
        var fieldMatch = control.className.match(/-field-container-([a-zA-Z0-9_-]+?)-(?:input|select|radio-button|label|checkbox)(?:\s|$)/);
        if (!fieldMatch) throw new Error('The form could not validate ' + field.label + '. Please refresh and try again.');
        var fieldId = fieldMatch[1];
        var fieldPrefix = prefix + '-field-container-' + fieldId;
        var required = host.querySelector('#' + fieldPrefix + '-required'), error = host.querySelector('#' + fieldPrefix + '-error');
        if (required) required.style.display = missing ? '' : 'none';
        if (error) error.style.display = malformed ? '' : 'none';
        // Match the original SDK's U()/Fr() targets: labels and the visual
        // checkbox element participate in the source .error rules too.
        host.querySelectorAll('.' + fieldPrefix + '-input, .' + fieldPrefix + '-select, .' + fieldPrefix + '-radio-button, .' + fieldPrefix + '-label').forEach(function (item) { item.classList.toggle('error', !!(missing || malformed)); });
        controls.forEach(function (item) {
          item.setAttribute('aria-invalid', String(!!(missing || malformed)));
          if ((missing || malformed) && (malformed ? error : required)) item.setAttribute('aria-errormessage', (malformed ? error : required).id);
          else item.removeAttribute('aria-errormessage');
        });
        if (missing || malformed) { valid = false; firstInvalid = firstInvalid || control; messages.push(field.label + (missing ? ' is required.' : ' is invalid.')); }
      });
      if (firstInvalid) firstInvalid.focus();
      return { values: values, valid: valid, messages: messages };
    }
    form.addEventListener('input', function () { if (!pending) submissionId = null; });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending) return;
      var checked;
      try { checked = valuesAndValidity(); }
      catch (error) { status.textContent = error.message || 'We could not validate the form. Please refresh and try again.'; status.style.display = ''; return; }
      if (!checked.valid) { status.textContent = checked.messages.join(' '); status.style.display = ''; return; }
      pending = true;
      var button = form.querySelector('[type="submit"]');
      var values = checked.values;
      submissionId = submissionId || uuid();
      button.disabled = true;
      status.textContent = ''; status.style.display = 'none';
      try {
        if (!window.pkFormSecurity) throw new Error('Please refresh the page and try again.');
        var securityHost = form;
        if (form.ownerDocument !== document) {
          securityHost = document.createElement('div');
          securityHost.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:min(300px,calc(100% - 24px));z-index:2147483646';
          document.body.appendChild(securityHost);
        }
        var token;
        try {
          status.textContent = 'Please complete the security check to send your form.'; status.style.display = '';
          token = await window.pkFormSecurity.token(securityHost, 'native_' + key);
          status.textContent = 'Sending your form…';
        }
        finally { if (securityHost !== form) securityHost.remove(); }
        var result = await request('shopify-submit', { form: key, values: values, page: location.href, submissionId: submissionId, turnstileToken: token, sourceTheme: String(window.Shopify && window.Shopify.theme && window.Shopify.theme.id || '') });
        if (result.ok !== true) throw new Error('Please try again.');
        write(visitorKey, 'saved');
        form.style.display = 'none';
        success.style.display = '';
        status.textContent = '';
        form.dataset.submitted = 'true';
        if (key === 'match') {
          var header = document.querySelector('.yas_header, [data-header-height]');
          var clearance = header ? header.getBoundingClientRect().height : 0;
          window.scrollTo({top:Math.max(0, window.scrollY + success.getBoundingClientRect().top - clearance),behavior:'instant'});
        }
        document.dispatchEvent(new CustomEvent('pkNativeFormSubmitted', { detail: { form: key } }));
        if (meta.redirect) setTimeout(function () { location.assign(meta.redirect); }, 5000);
      } catch (error) {
        status.textContent = error.message || 'We could not send the form. Please try again.'; status.style.display = '';
      } finally { pending = false; button.disabled = false; }
    });
    host.querySelectorAll('[id$="-close-action"], [id*="-action-"]').forEach(function (button) {
      var originalAction = button.id.split('-action-')[1];
      if (!button.id.endsWith('-close-action') && !['66bb5bcc8e3ca9e9c9b75a8e', '689cebcafa4af37287d90dd0'].includes(originalAction)) return;
      button.addEventListener('click', function () {
        if (!mayClose(key) && form.dataset.submitted !== 'true') return;
        if (popup && popup.contains(form)) popup.close();
        else if (document.body.hasAttribute('data-pk-native-standalone')) location.assign(key === 'wishlist' ? '/pages/wishlist' : '/');
      });
    });
  }
  async function originalFontsReady(root) {
    var doc = root.ownerDocument || root;
    var descriptors = new Set();
    root.querySelectorAll('*').forEach(function (element) {
      if (['STYLE', 'SCRIPT', 'LINK'].includes(element.tagName)) return;
      var css = doc.defaultView.getComputedStyle(element);
      if (css.fontFamily.includes('Omnisend')) descriptors.add(css.fontStyle + ' ' + css.fontWeight + ' ' + css.fontSize + ' ' + css.fontFamily);
    });
    await Promise.all(Array.from(descriptors, function (font) {
      return doc.fonts.load(font).then(function (faces) {
        if (!faces.length) throw new Error('Original form font unavailable');
      });
    }));
  }
  async function mount(host, key) {
    var serverMeta = host.querySelector('[data-pk-original-form-meta]');
    if (serverMeta) {
      var original = JSON.parse(serverMeta.textContent);
      var serverForm = host.querySelector('form');
      bind(serverForm, key, original, host);
      serverForm.removeAttribute('onsubmit');
      host.dataset.pkHydrated = 'true';
      return original;
    }
    // Keep the original presentation hidden until its own fonts are ready.
    // Do not expose fallback typography and repaint it with the source font.
    var previousDisplay = host.style.display;
    host.style.display = 'none';
    presentationPromise = presentationPromise || fetch(presentationURL, {credentials: 'omit'}).then(function (response) { if (!response.ok) throw new Error('Form presentation unavailable'); return response.json(); });
    var result = (await presentationPromise)[key];
    var assetBase = presentationURL.substring(0, presentationURL.lastIndexOf('/') + 1);
    if (result.document) {
      var frame = document.createElement('iframe');
      frame.title = 'Breeder Application';
      // The original was a separate document: keep its original document cascade.
      frame.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;border:0;z-index:200000;background:#f2f6fa';
      var ready = new Promise(function (resolve) { frame.addEventListener('load', resolve, {once:true}); });
      frame.srcdoc = result.document.replaceAll('__PK_ASSET_BASE__', assetBase);
      host.appendChild(frame); await ready;
      var doc = frame.contentDocument;
      doc.querySelector('.omnisend-form-' + result.id + '-content').style.display = '';
      bind(doc.querySelector('form'), key, result, doc);
      await originalFontsReady(doc);
      result.frame = frame;
      host.style.display = previousDisplay;
      return result;
    }
    var html = result.html.replaceAll('__PK_ASSET_BASE__', assetBase);
    if (document.querySelector('[data-pk-original-inline-fonts]')) {
      // Do not replace the already decoded server-page fonts when a popup opens.
      html = html.replace(/@font-face\s*\{[^}]*pk-original-font-(?:2|3)\.woff[^}]*\}/g, '');
    }
    host.innerHTML = html;
    var content = host.querySelector('.omnisend-form-' + result.id + '-content');
    if (content && content.style.display === 'none') content.style.display = '';
    bind(host.querySelector('form'), key, result, host);
    await originalFontsReady(host);
    host.style.display = previousDisplay;
    return result;
  }
  async function showPopup(key, explicit) {
    if (popup || showing || (!explicit && read(visitorKey))) return;
    var last = Number(read(cooldownKey + '-' + key) || 0);
    if (!explicit && Date.now() - last < 7 * 86400000) return;
    showing = true;
    var serverFrame = key === 'breeder' && document.querySelector('iframe[data-pk-server-breeder]');
    if (serverFrame) {
      serverFrame.style.display = 'block';
      try {
        if (serverFrame.contentDocument.readyState !== 'complete') {
          await new Promise(function (resolve) { serverFrame.addEventListener('load', resolve, {once:true}); });
        }
        var serverDoc = serverFrame.contentDocument;
        var serverForm = serverDoc.querySelector('form');
        if (!serverFrame.dataset.pkHydrated) {
          var serverMeta = JSON.parse(serverDoc.querySelector('[data-pk-original-form-meta]').textContent);
          bind(serverForm, key, serverMeta, serverDoc);
          serverForm.removeAttribute('onsubmit');
          serverFrame.dataset.pkHydrated = 'true';
        }
        popup = {contains:function(node){return serverDoc.contains(node);},close:function(){serverFrame.style.display='none';popup=null;showing=false;}};
        write(cooldownKey + '-' + key, String(Date.now()));
      } catch (_) { serverFrame.style.display = 'none'; showing = false; }
      return;
    }
    var content = document.createElement('div');
    document.body.appendChild(content);
    try {
      var meta = await mount(content, key);
      if (meta.frame) {
        popup = {contains:function(node){return meta.frame.contentDocument.contains(node);},close:function(){content.remove();popup=null;showing=false;}};
        write(cooldownKey + '-' + key, String(Date.now()));
        return;
      }
      var container = content.querySelector('.omnisend-form-' + meta.id + '-container');
      var previousFocus = document.activeElement;
      function close() { document.removeEventListener('keydown', onKey); content.remove(); popup = null; showing = false; if (previousFocus && previousFocus.isConnected) previousFocus.focus(); }
      function onKey(event) {
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        var controls = Array.from(content.querySelectorAll('button,input,[href],[tabindex="0"]')).filter(function (element) { return !element.disabled && element.getClientRects().length; });
        var first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      document.addEventListener('keydown', onKey);
      popup = { contains: function (node) { return content.contains(node); }, close: close };
      container.querySelector('[class$="-content-inner"]').focus({preventScroll:true});
      write(cooldownKey + '-' + key, String(Date.now()));
    } catch (_) { content.remove(); showing = false; }
  }
  function messageTraffic() {
    var params = new URLSearchParams(location.search);
    return params.get('utm_source') === 'omnisend' || params.has('omnisendContactID') || params.has('omnisendContactId') || params.has('pk_m');
  }
  function start() {
    function nativeLinks(root) {
      root.querySelectorAll('a[href]').forEach(function (link) {
        var url; try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return; }
        if (url.origin === location.origin && url.pathname === '/pages/for-breeders' && url.hash === '#breeder-application') {
          if (!link.hasAttribute('data-pk-native-form')) {
            link.setAttribute('data-pk-native-form', 'breeder');
            link.addEventListener('click', function (event) {
              if (location.pathname.replace(/\/$/, '') !== '/pages/for-breeders') return;
              event.preventDefault(); showPopup('breeder', true);
            });
          }
          return;
        }
        if (!['omniform1.com', 'formsv2.soundestlink.com', 'forms.soundestlink.com'].includes(url.hostname) && !/^\/apps\/pk-contact-form\/form\//.test(url.pathname)) return;
        var ids = { '6403a509653128bbaea27a4f': 'breeder', '67bf2c43927c938a9be269b5': 'match', '65ec902d75b6cc4e1b8f7ee4': 'match', '66e32e56b864617c8e630139': 'newsletter', '689a626e369d123b995a2b0d': 'wishlist' };
        Object.keys(ids).some(function (id) {
          if (!url.pathname.includes(id)) return false;
          if (ids[id] === 'match') link.href = '/pages/match-check-confirm';
          else if (ids[id] === 'wishlist') link.href = '/pages/wishlist#wishlist-application';
          else {
            var key = ids[id];
            link.href = '#' + key + '-application';
            link.addEventListener('click', function (event) { event.preventDefault(); showPopup(key, true); });
          }
          return true;
        });
      });
    }
    nativeLinks(document);
    if (location.pathname.replace(/\/$/, '') === '/pages/for-breeders' && location.hash === '#breeder-application') showPopup('breeder', true);
    new MutationObserver(function (changes) { changes.forEach(function (change) { change.addedNodes.forEach(function (node) { if (node.nodeType === 1) nativeLinks(node.parentElement || node); }); }); }).observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll('[data-native-marketing-host]').forEach(function (host) {
      mount(host, host.dataset.nativeMarketingHost).catch(function () { host.textContent = 'The form could not load. Please refresh the page.'; });
    });
    var wishlist = ['/pages/wishlist', '/pages/wishlist-1', '/pages/wishlists'].includes(location.pathname.replace(/\/$/, '')) || !!document.querySelector('[data-pk-wishlist-page]');
    if (wishlist && location.hash === '#wishlist-application') showPopup('wishlist', true);
    if (!document.body.hasAttribute('data-pk-native-standalone') && !read(visitorKey) && !read('omni_email') && !document.querySelector('script[data-pk-storefront-customer-known="true"]') && !messageTraffic()) {
      if (wishlist) showPopup('wishlist');
      else {
        setTimeout(function () { showPopup('newsletter'); }, 15000);
        var scrolled = function () {
          var extent = document.documentElement.scrollHeight - innerHeight;
          if (extent > 0 && scrollY / extent >= .35) { window.removeEventListener('scroll', scrolled); showPopup('newsletter'); }
        };
        window.addEventListener('scroll', scrolled, { passive: true });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
